export type StudentVoiceMail = {
    id: number
    studentProfileId: number
    departmentId: number
    provider: "twilio"
    duration: number
    recordingUrl: string
    status: "unread" | "read"
    readAt: string
    readBy: number
    createdAt: string
}

export const VoiceMailReadStatusOptions = [
    {id: "unread", name: "Unread"},
    {id: "read", name: "Read"}
]
